/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// TODO #458 Integrovat do nové třídy ViewerManager.
/**
 * Zdroj organizátorů zobrazování obsahu.
 * Dovoluje přístup ke všem vytvořeným organizátorům.
 * Aktuálně je organizátor v daný okamžik pouze jeden,
 * nebo žádný (před spuštěním, po odinstalaci).
 */
class ViewerDirectorResource {
  /**
   * Vytvoří instanci.
   * @param {ViewerDirectorFactory} factory
   */
  constructor(factory) {
    this.directorArray = [];
    this.factory = factory;
  }

  /**
   * Vytvoří nový organizátor zobrazování obsahu.
   * @param {HTMLElement} el ELement, do kterého se prolínač vykresluje.
   * @returns {ViewerDirector} Vytvořený organizátor.
   */
  create(el) {
    const director = this.factory.create(el);
    this.directorArray.push(director);
    return director;
  }

  /**
   * Zruší vytvořený organizátor zobrazování obsahu.
   * @param {ViewerDirector} director
   * @returns {undefined}
   */
  destroy(director) {
    const { directorArray } = this;
    const index = directorArray.indexOf(director);
    if (index === -1) {
      throw new Error(`Unknown director "${director}".`);
    }
    directorArray.splice(index, 1);
    director.destroy();
  }

  /**
   * Zjistí všechny aktuálně vytvořené organizátory zobrazování obsahu.
   * @returns {Array.<ViewerDirector>}
   */
  getAll() {
    return Array.from(this.directorArray);
  }
}

export default ViewerDirectorResource;
